import SentryBoundaryFallback from 'components/SentryBoundaryFallback';

const sentryBoundaryFallback = ({ resetError }) => {
  return <SentryBoundaryFallback resetError={resetError} />;
};

export default sentryBoundaryFallback;